"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
var rgb2xyz_1 = require("./rgb2xyz");
exports.rgb2xyz = rgb2xyz_1.rgb2xyz;
var rgb2hsl_1 = require("./rgb2hsl");
exports.rgb2hsl = rgb2hsl_1.rgb2hsl;
var rgb2lab_1 = require("./rgb2lab");
exports.rgb2lab = rgb2lab_1.rgb2lab;
var lab2xyz_1 = require("./lab2xyz");
exports.lab2xyz = lab2xyz_1.lab2xyz;
var lab2rgb_1 = require("./lab2rgb");
exports.lab2rgb = lab2rgb_1.lab2rgb;
var xyz2lab_1 = require("./xyz2lab");
exports.xyz2lab = xyz2lab_1.xyz2lab;
var xyz2rgb_1 = require("./xyz2rgb");
exports.xyz2rgb = xyz2rgb_1.xyz2rgb;
//# sourceMappingURL=index.js.map